<template>
  <div class="date-container">
    <label class="label" for="date-picker">
      {{ $t("compliance_reviews.search.date") }}
    </label>
    <date-picker
      class="date-picker-field"
      :id="'date-picker'"
      :placeholder="$t('compliance_reviews.search.date')"
      v-model="dateRangeValue"
      range
    />
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  props: {
    complianceReviewDateRange: { type: Array, default: null }
  },
  computed: {
    dateRangeValue: {
      get() {
        return this.complianceReviewDateRange;
      },

      set(value) {
        return this.$emit("update:complianceReviewDateRange", value);
      }
    }
  }
};
</script>
<style scoped>
.date-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;

  &:focus-within {
    color: var(--text-brand);
  }
}

.label {
  display: inline-block;
  flex: 0 1 auto;
  padding-bottom: 0.1rem;
  font-size: 1rem;
  font-weight: bold;
}

.date-picker-field {
  &:focus-within {
    outline: var(--default-focus-outline);
  }

  input {
    height: var(--input-height);
    padding: var(--input-padding-bordered);
    color: var(--text-color-base);
    background: var(--input-default-background);
    border: var(--input-border);
  }

  input:hover {
    background: var(--button-default-hover-background);
  }

  .mx-icon-calendar,
  .mx-icon-clear {
    color: var(--text-color-base);
  }
}
</style>
<style>
.mx-datepicker-range {
  width: 15rem;
}

.mx-datepicker-popup {
  background-color: var(--input-default-background);
}

.mx-datepicker-main,
.mx-btn {
  color: var(--date-picker-regular-color);
}

.mx-table-date .today {
  color: var(--brand-primary);
}

.mx-table-date .cell.not-current-month {
  color: var(--date-picker-disabled-color);
  pointer-events: none;
}

.mx-btn:hover {
  color: var(--brand-primary);
  border-color: var(--brand-primary-darker);
}

.mx-calendar-content .cell.in-range,
.mx-calendar-content .cell.hover-in-range,
.mx-calendar-content .cell:hover {
  color: var(--white);
  background-color: var(--brand-primary);
}

.mx-calendar-content .cell.active {
  background-color: var(--brand-primary-darker);
}
</style>
